window.main = window.main || {};
main.init = function () { 
  main.hidePopup();
  main.openDrawer();
  main.closeDrawer();
  main.btnAddtocart();
  main.quantityBox();
  main.newsletter();
  main.accordion();
};

jQuery(document).ready(function(){
  "use strict"; 
});

/********************************************************
#ADDITIONS
********************************************************/
main.openDrawer = function(){    
  $('.js-drawer-open').click(function(e){
    e.preventDefault(); 
    var content = $(this).data('content');
    $('body').toggleClass('active-popup');
    $('.overlay-background').toggleClass('active');
    $('.'+content).toggleClass('active');   
    return false;    
  });
};

main.closeDrawer = function(){    
  $('.drawer-close').click(function(e){
    e.preventDefault(); 
    var content = $(this).data('content');
    $('body').toggleClass('active-popup');
    $('.overlay-background').toggleClass('active');
    $('.cart-drawer-wrapper').toggleClass('active');   
    return false;    
  });
};

main.hidePopup = function () {  
  $(document).on('click touch', function(e) { 
    var popup = $(".theme-popup");
    if (!popup.is(e.target) && popup.has(e.target).length === 0) {
      $('body').removeClass('active-popup');
      $('.overlay-background').removeClass('active');
      popup.removeClass('active');      
    }
  });
};

main.newsletter = function() {
  var alertNewsletter;
  $('.js-vela-newsletter').each(function() {
    var $form = $(this);
    $form.on('submit', function(event) {
      event.preventDefault();
      $('.js-alert-newsletter').remove();
      $.ajax({
        type: $form.attr('method'),
        url: $form.attr('action'),
        data: $form.serialize(),
        cache: false,
        dataType: 'json',
        contentType: 'application/json; charset=utf-8',
        success: function(data) {
          if (data.result === 'success') {
            $form.prepend(alertNewsletter(theme.strings.newsLetterSucces ,'success'));
            $('.js-input-newsletter').val('');
          } else {
            $form.prepend(alertNewsletter(data.msg.replace('0 - ', '') ,'error'));
          }
        },
        error: function(err) {
          $form.prepend(alertNewsletter(err ,'error'));
        }
      });
    });
  });
  alertNewsletter = function(message, type) {
    var alert = '<div class="js-alert-newsletter alert-dismissible  alert alert-' + type + '">' + message + '<button type="button" data-dismiss="alert" aria-hidden="true" aria-label="Close" class="btn--close">x</button></div>';
    return alert;
  };
  $('.js-alert-newsletter .btn--close').on('click', function(e){
    console.log('fdfd');
  });
};
main.accordion = function(){
  function accordionFooter(){
      if ( $(window).width() <= 767){
          if(!$('.footer-link-list').hasClass('accordion')){
              $('.footer-link-list .footer-title').on('click', function(e){
                  $(this).toggleClass('active').parent().find('.footer-link-list-content').stop().slideToggle('medium');
                  e.preventDefault();
              });
              $('.footer-link-list').addClass('accordion').find('.footer-link-list-content').slideUp('fast');
          }
      }
      else {
          $('.footer-link-list .footer-title').removeClass('active').off().parent().find('.footer-link-list-content').removeAttr('style').slideDown('fast');
          $('.footer-link-list').removeClass('accordion');
      }
  }
  accordionFooter();
  $(window).resize(accordionFooter);
};

/********************************************************
# SWIPER CAROUSEL
********************************************************/
jQuery(document).ready(function(){

  $(".swiper-container:not(.product-media)").each( function(){

    var item = $(this).attr('data-items'),
    	xs_item = $(this).attr('data-xs'),
    	sm_item = $(this).attr('data-sm'),
    	md_item = $(this).attr('data-md'),
    	lg_item = $(this).attr('data-lg'),
    	margin = $(this).attr('data-margin'),    	 
    	datarow = $(this).attr('data-row'),
    	direction = $(this).attr('data-direction'),
    	loop = $(this).attr('data-loop'),
    	autoplay = $(this).attr('data-autoplay');   

    if (typeof item !== typeof undefined && item !== false) {    
    } else{
      item = 4;
    }

    if (typeof xs_item !== typeof undefined && xs_item !== false) {    
    } else{
      xs_item = 1;
    }

    if (typeof sm_item !== typeof undefined && sm_item !== false) {    
    } else{
      sm_item = 2;
    }

    if (typeof md_item !== typeof undefined && md_item !== false) {    
    } else{
      md_item = 3;
    }

    if (typeof lg_item !== typeof undefined && lg_item !== false) {    
    } else{
      lg_item = 4;
    }

    if (typeof margin !== typeof undefined && margin !== false) {    
    } else{
      margin = 30;
    }

    if (typeof datarow !== typeof undefined && datarow !== false) {    
    } else{
      datarow = 1;
    }


    if (typeof direction !== typeof undefined && direction !== false) {    
    } else{
      direction = 'horizontal';
    }

    if (typeof loop !== typeof undefined && loop !== false) {    
    } else{
      loop = false;
    }

    if (typeof autoplay !== typeof undefined && autoplay !== false) {    
    } else{
      autoplay = 9999999;
    }

    var config = {
      spaceBetween: margin,
      slidesPerView: item,
      direction: direction,
      slidesPerColumn: datarow,
      loop: loop,
      paginationClickable: true,
      autoHeight: true,

      autoplay: {
        delay: autoplay,
        disableOnInteraction: false,
      },
      
      pagination: {
        el: '.swiper-pagination',
      },

      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },

      scrollbar: {
        el: '.swiper-scrollbar',
      },
      mousewheel: false,
      keyboard: true,
      breakpoints: {
        0: {
          slidesPerView: xs_item,
          spaceBetween: 10
        },

        479: {
          slidesPerView: sm_item,
          spaceBetween: 12
        },

        767: {
          slidesPerView: md_item,
          spaceBetween: 14
        },

        991: {
          slidesPerView: lg_item,
          spaceBetween: 16
        },
        1360: {
          slidesPerView: item,
          spaceBetween: margin
        }

      }
    };		
    var swiper = new Swiper(this, config);
  });  
});
 
jQuery(document).ready(function(){

    var delay = $('.main-slider').attr('data-delay');
    if (typeof delay !== typeof undefined && delay !== false) {    
    } else{
      delay = 8000;
    }

    var width = $('.main-slider').attr('data-width');
    if (typeof width !== typeof undefined && width !== false) {    
    } else{
      width = 1920;
    }

    var height = $('.main-slider').attr('data-height');
    if (typeof height !== typeof undefined && height !== false) {    
    } else{
      height = 775;
    }

    var pTags = $(".load-slideshow li");
    if ( pTags.parent().is("ul")) {
      pTags.unwrap();
    }   
    
    if ( pTags.parent().is("div.shopify-section")) {
      pTags.unwrap();
    } 
    
    (function($){
      jQuery.fn.checkEmpty = function() {
        return !$.trim(this.html()).length;
      };
    }(jQuery));
    
    $('.load-slideshow .shopify-section').each( function(){      
      if($(this).checkEmpty()){
        $(this).remove();
      }
    });
    
    $(".load-slideshow > li").each( function(){
      $(this).appendTo($('#rev_slider > ul')); 
    });

    // jQuery('#rev_slider').show().revolution({ 
    //   dottedOverlay: 'none',
    //   delay: delay,
    //   startwidth: width, 
    //   startheight: height, 

    //   hideThumbs:200,
    //   thumbWidth:100,                            
    //   thumbHeight:50, 
    //   thumbAmount:5,

    //   navigationType:"both",                  
    //   navigationArrows:"",        
    //   navigationStyle: 'preview3',             
    //   touchenabled:"on",                      
    //   onHoverStop:"on",        

    //   navOffsetHorizontal:0,
    //   navOffsetVertical:50,

    //   swipe_velocity: 0.7, 
    //   swipe_min_touches: 1,
    //   swipe_max_touches: 1,
    //   drag_block_vertical: false,

    //   spinner: 'spinner2',
    //   keyboardNavigation: 'on',

    //   navigationHAlign: 'center',
    //   navigationVAlign: 'bottom',
    //   navigationHOffset: 20,
    //   navigationVOffset: 20,

    //   soloArrowLeftHalign: '',
    //   soloArrowLeftValign: '',
    //   soloArrowLeftHOffset: 0,
    //   soloArrowLeftVOffset: 0,

    //   soloArrowRightHalign: '',
    //   soloArrowRightValign: '',
    //   soloArrowRightHOffset: 0,
    //   soloArrowRightVOffset: 0,

    //   shadow: 0,
    //   fullWidth: 'on',
    //   fullScreen: 'off', 

    //   stopLoop: 'off',
    //   stopAfterLoops: -1,
    //   stopAtSlide: -1,

    //   shuffle: 'off',
    //   autoHeight: 'on',
    //   forceFullWidth: 'off',
    //   hideTimerBar: 'off',

    //   hideNavDelayOnMobile: 1500,
    //   hideThumbsOnMobile: 'off',
    //   hideBulletsOnMobile: 'off',
    //   hideArrowsOnMobile: 'off',
    //   hideThumbsUnderResolution: 0,

    //   hideSliderAtLimit: 0,
    //   hideCaptionAtLimit: 0,
    //   hideAllCaptionAtLilmit: 0,
    //   startWithSlide: 0
    // });
})

/********************************************************
# BUTTON ADDTOCART
********************************************************/
main.btnAddtocart = function (){
  $('.product-form__cart-submit').click(function(event) { 
    event.preventDefault();
    var form = $(this).closest('form.product-form');

    if ($(this).attr('disabled') != 'disabled') {
      var data = form.serialize(); 
 
      main.ajaxAddToCart(data);

      // if (!variant_id) {
      //   variant_id = $(window.product_detail_form +' input[name=id]').val();
      // }
      // var quantity = $(window.product_detail_form +' input[name=quantity]').val();
      // if (!quantity) {
      //   quantity = 1;
      // }
      // var title = $(window.product_detail_name).html();
      // var image = $(window.product_detail_mainImg).attr('src');
      // gred.doAjaxAddToCart(variant_id, quantity, title, image);
    }
    return false;
  });
} 

/********************************************************
# PRODUCT 
********************************************************/
main.mediaThumbs = function(index){
  var galleryThumbs = new Swiper('.product-media-thumbs', {
    speed: 600,
    spaceBetween: 10,
    slidesPerView: 4,
    watchSlidesVisibility: true,
    watchSlidesProgress: true, 
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev', 
    }, 
  }); 

  var galleryTop = new Swiper('.product-media-main', {
    speed: 600,
    spaceBetween: 0, 
    slidesPerView: 1,    
    thumbs: {
      swiper: galleryThumbs,  
    },
  });    

  if(index != null){
    if(index == 0){
      galleryThumbs.slideTo(1, 600);   
      galleryTop.slideTo(1, 600);      
      galleryThumbs.slidePrev(600);  
      galleryTop.slidePrev(600);         

    } else{
      galleryThumbs.slideTo(index, 600);    
      galleryTop.slideTo(index, 600);  

    }
  } 
}

main.productSelectCallback = function(options){
  var variant = options.variant,
      btn_ATC = $('.product-form__cart-submit'),
      btn_ATC_text = $('.product-form__cart-submit .add-to-cart-text');

  if(variant){ 
    //Update Price    
    if(variant.compare_at_price > variant.price){       
      $('.product-single__price .price').addClass('price--on-sale'); 
      $('.product-single__price .price__sale .price-item--sale').html(Shopify.formatMoney(variant.price, window.shop.formatMoney));
      $('.product-single__price .price__sale .price-item--regular').html(Shopify.formatMoney(variant.compare_at_price, window.shop.formatMoney));
    } else{      
      $('.product-single__price .price').removeClass('price--on-sale');
      $('.product-single__price .price__regular .price-item--regular').html(Shopify.formatMoney(variant.price, window.shop.formatMoney));
    }

    //Update available
    if(variant.available) {
        $('.product-single__price .price').removeClass('price--sold-out'); 
    } else{
        $('.product-single__price .price').addClass('price--sold-out'); 
    }

    //Update ADDTOCART button  
    if(variant.available) {
      btn_ATC.removeClass('disabled').prop('disabled', false);
      btn_ATC_text.html(window.product.add_to_cart);    
    } else{
      btn_ATC.addClass('disabled').prop('disabled', true);
      btn_ATC_text.html(window.product.sold_out); 
    }

    //Update main and thumbnai images 
    if(variant.featured_image != null){
      var title = variant.title,  
          img = variant.featured_image.src,
          img = img.replace("https:", ""); 

      var i_index = $(".product-media-thumbs .swiper-slide[data-img='"+img+"']").attr("data-index");    
      if (typeof i_index !== "undefined") {   
        var current_item = $(".product-media-thumbs .swiper-slide.swiper-slide-thumb-active").attr("data-index");  
     
        if(current_item !== i_index){    
          main.mediaThumbs(i_index);      
        }           
      }   
    }  
  } 

} 

 
//DO AJAX ADDTOCART
main.ajaxAddToCart = function(data){ 
  console.log(data);
  $.ajax({
    type: "post",
    url: "/cart/add.js",
    data: data, 
    dataType: 'json', 
    beforeSend: function() {  
      console.log('beforeSend');
    },
    success: function(msg) {  
      console.log('success');
    },
    error: function(xhr, text) {
      $('.error-message').text($.parseJSON(xhr.responseText).description);
      console.log('error');
    }
  }); 
} 

//Quantity Box
main.quantityBox = function(){   

  // Plus button
  $('.quantity-box--plus').click(function(e){      
      e.preventDefault();
      var qty = $(this).closest('.quantity-box').find('.product-form__input--quantity');
      var currentVal = parseInt(qty.val());

      console.log('1111');

      if (!isNaN(currentVal)) { 
        qty.val(currentVal + 1);
      } else {   
          qty.val(1);
      }
  });

  // Minus button
  $('.quantity-box--minus').click(function(e){      
      e.preventDefault();
      var qty = $(this).closest('.quantity-box').find('.product-form__input--quantity');
      var currentVal = parseInt(qty.val());

      if (!isNaN(currentVal) && currentVal > 1) {
        qty.val(currentVal - 1);
      } else {    
          qty.val(1);
      }
  }); 
}

/********************************************************
# INIT
********************************************************/
$(main.init);